import { render, staticRenderFns } from "./ass-item-select.vue?vue&type=template&id=352ee159"
import script from "./ass-item-select.vue?vue&type=script&lang=js"
export * from "./ass-item-select.vue?vue&type=script&lang=js"
import style0 from "./ass-item-select.vue?vue&type=style&index=0&id=352ee159&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports